<template>

  <div class="map-wrapper">

    <div class="map">

      <l-map
        v-if="showMap"
        :zoom="zoom"
        :center="center"
        :options="mapOptions"
        style="height: 100%"
        @update:center="centerUpdate"
        @update:zoom="zoomUpdate"
      >

        <l-tile-layer
          :url="url"
          :attribution="attribution"
        />

        <template v-if="mapIndicatorId === 2">
          <l-marker v-for="(initiative, index) in initiativesToShow"
                    :lat-lng="preparedLatLng(initiative.coordinates[0], initiative.coordinates[1])"
                    :key="index"
                    :icon="markerIcon"
          >
            <l-popup>
              <div><strong>{{ initiative.title }}</strong></div>
              <div>Sector: {{ initiative.sector }}</div>
              <div>Type: {{ initiative.type }}</div>
              <div>Location: {{ initiative.location }}</div>
              <div v-if="initiative.url"><a :href="initiative.url" target="_blank">More info</a></div>
            </l-popup>
          </l-marker>
        </template>

        <l-geo-json
          :geojson="countriesDataAll"
          :options="geojsonOptions"
          :optionsStyle="geojsonOptionsStyleBase"
        />

        <l-geo-json
          v-if="mapIndicatorId < 2"
          :geojson="filteredCountries"
          :options="geojsonOptions"
          :optionsStyle="geojsonOptionsStyleOverlay"
        />

      </l-map>

    </div>

    <div v-if="mapIndicatorId === 2" class="map-filters">
      <b-form-checkbox-group
        id="checkbox-group-1"
        class="checkbox-group"
        v-model="checkedSectors"
        :options="checkboxGroupOptions"
      ></b-form-checkbox-group>
    </div>

<!--    <ul>-->
<!--      <li>Center: {{ currentCenter }}</li>-->
<!--      <li>Zoom: {{ currentZoom }}</li>-->
<!--    </ul>-->

  </div>

</template>

<script>
  import DataInitiatives from './data/initiatives.json'
  import { latLng, icon } from "leaflet";
  import { LGeoJson, LMap, LMarker, LPopup, LTileLayer } from "vue2-leaflet";
  import countriesDataAll from './data/countries-all.geo.json'
  import indicators from './data/indicators.json'

  export default {
    name: 'MapInitiatives',
    components: {
      LGeoJson,
      LMap,
      LMarker,
      LPopup,
      LTileLayer,
    },
    mounted() {
      // Get distinct sectors from database
      this.distinctSectors = this.getDistinctSectors()
      // Initialise checked sectors
      this.checkedSectors = this.distinctSectors
    },
    props: {
      mapIndicatorId: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        zoom: 2.2,
        center: latLng(30, 0),
        // url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        // url: 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png',
        url: '',
        // attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>',
        attribution: '',
        mapOptions: {
          zoomSnap: 0.5
        },
        showMap: true,
        currentZoom: 2,
        currentCenter: latLng(47.41322, -1.219482),
        distinctSectors: [],
        checkedSectors: [],
        // GeoJSON related stuff below...
        countriesDataAll,
        indicators,
        // Credit: https://jsfiddle.net/Boumi/t87cj3rs/
        geojsonOptions: {
          onEachFeature: function onEachFeature(feature, layer) {
            layer.bindPopup(feature.properties.admin);
          }
        },
        geojsonOptionsStyleOverlay: {
          "color": "#F4633A",
          "fillColor": "#efbd82",
          "weight": 1,
          "opacity": 1,
          "fillOpacity": 1,
        },
        geojsonOptionsStyleBase: {
          "color": "#10322B",
          "weight": 1,
          "opacity": 0.3,
        },
        markerIcon: icon({
          iconUrl: "/map-pin.png",
          iconSize: [26, 34],
          iconAnchor: [13, 34]
        }),
      };
    },
    methods: {
      zoomUpdate(zoom) {
        this.currentZoom = zoom;
      },
      centerUpdate(center) {
        this.currentCenter = center;
      },
      getDistinctSectors() {
        // Credit: https://codeburst.io/javascript-array-distinct-5edc93501dc4
        return [...new Set(DataInitiatives.initiatives.map(initiative => initiative.sector))]
      },
      preparedLatLng(lat, lng) {
        // We can't use the latLng method directly when binding the prop so we add this intermediary method.
        return latLng(lat, lng)
      },
    },
    computed: {
      checkboxGroupOptions() {
        let options = []
        this.distinctSectors.forEach(
          sector =>
            options.push(
              { text: sector, value: sector }
            )
        )
        return options
      },
      // currentIndicator() {
      //   return indicators.indicator1
      //   this.mapIndicatorId
      // },
      initiativesToShow() {
        // Returns initiatives whose category has been selected using the checkboxes.
        return DataInitiatives.initiatives.filter(
          initiative => this.checkedSectors.includes(initiative.sector)
        )
      },
      filteredCountries() {
        const countriesDataFiltered = []
        const subsetCountryCodes = indicators[this.mapIndicatorId].countries
        countriesDataAll.features.forEach(function(country) {
          subsetCountryCodes.forEach(function(indicatorCountryCode) {
            if (country.properties.iso_a2 === indicatorCountryCode) {
              // console.log("Match: " + indicatorCountryCode)
              countriesDataFiltered.push(country)
            }
          })
        })
        // console.log(countriesDataFiltered)
        return countriesDataFiltered
      }
    }
  }
</script>

<style src="./MapInitiatives.scss" lang="scss"></style>
